import { createSlice } from "@reduxjs/toolkit";
import { Region } from "../utils/httpclient";

interface RegionState {
  regionData: Region;
  localeId: string;
}

const initialState: RegionState = {
  regionData: { countryName: "United States", countryCode: "US", languageCode: "EN" },
  localeId: "",
};

const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {
    setRegionData(state, action) {
      state.regionData = action.payload;
    },
    setLocaleId(state, action) {
      state.localeId = action.payload;
    },
  },
});

export const { setRegionData, setLocaleId } = regionSlice.actions;
export default regionSlice.reducer;